import { render, staticRenderFns } from "./GptSetup.vue?vue&type=template&id=77e5ab26"
import script from "./GptSetup.vue?vue&type=script&lang=js"
export * from "./GptSetup.vue?vue&type=script&lang=js"
import style0 from "./GptSetup.vue?vue&type=style&index=0&id=77e5ab26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports